<template>
  <div>
    <top-menu :user="user" :topMenuStatus="topMenuStatus" :active="topMenuActive" @defaultActive="defaultActive"
      :agent="agent" :userLevel="userLevel" :userCenterCount="userCenterCount" @changeStatus="changeStatus"
      @voucher="voucher" @cloudDisk="cloudDisk"></top-menu>
    <div style="width:100%;height:680px;overflow-y:auto;">
      <div class="main-text">
        <div class="left-nav">
          <ul>
            <li ref="account" :class="menu[0].check" @click="menuClick('/home/account')"><a
                href="javascript:void(0);"><i class="el-icon-s-home"></i>我的账号</a><span></span></li>
            <li ref="orders" :class="menu[1].check" @click="menuClick('/home/orders')"><a href="javascript:void(0);"><i
                  class="el-icon-document"></i>产品订单</a><span></span></li>
            <li ref="dataOrders" :class="menu[2].check" @click="menuClick('/home/dataOrders')"><a
                href="javascript:void(0);"><i class="el-icon-document"></i>数据订单</a><span></span></li>
            <li ref="subscriptionOrders" :class="menu[3].check" @click="menuClick('/home/subscriptionOrders')"><a
                href="javascript:void(0);"><i class="el-icon-document"></i>周期任务</a><span></span></li>
            <li ref="message" :class="menu[4].check" @click="menuClick('/home/message')"><a
                href="javascript:void(0);"><i class="el-icon-chat-dot-square"></i>我的消息</a><span></span></li>
            <li ref="voucher" :class="menu[5].check" @click="menuClick('/home/voucher')"><a
                href="javascript:void(0);"><i class="el-icon-s-ticket"></i>代金券</a><span></span></li>
            <li ref="ftpmanager" :class="menu[6].check" @click="menuClick('/home/ftpmanager')"><a
                href="javascript:void(0);"><i class="el-icon-takeaway-box"></i>交付管理</a><span></span></li>
            <li ref="cloudDisk" :class="menu[7].check" @click="menuClick('/home/cloudDisk')"><a
                href="javascript:void(0);"><i class="el-icon-cloudy"></i>我的云盘</a><span></span></li>
            <li ref="invoice" :class="menu[8].check" @click="menuClick('/home/invoice')"><a
                href="javascript:void(0);"><i class="el-icon-position"></i>发票管理</a><span></span></li>
            <li><a href="#"><i class="el-icon-copy-document"></i>其他功能</a><span></span></li>
          </ul>
        </div>
        <router-view @showauthor="showauthor" @defaultActive="defaultActive" @changeUser="currentUser"
          :orderStatus="orderStatus" @topMenuStatus="getTopMenuStatus"></router-view>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="authorFormVisible" @close="closeHandler" append-to-body
      :close-on-click-modal="false" custom-class="authordialog">
      <authorItem :authType.sync="authType" @closeDialog="closeDialog" @changeTitle="getTitle"></authorItem>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '../../common/eventBus.js'
import authorItem from './authorItem'
import TopMenu from './feedback'
export default {
  name: 'orderlist',
  components: {
    authorItem,
    TopMenu
  },
  data () {
    return {
      currentPage: 1,
      authorFormVisible: false,
      authType: false,
      title: '选择认证类型',
      user: {
        userId: '',
        userName: '',
        nickName: '',
        sex: '',
        rank: ''
      },
      topMenuActive: true,
      topMenuStatus: '',
      agent: '',
      userLevel: '',
      orderStatus: '',
      menu: [
        {
          path: '/home/account',
          check: ''
        },
        {
          path: '/home/orders',
          check: ''
        },
        {
          path: '/home/dataOrders',
          check: ''
        },
        {
          path: '/home/subscriptionOrders',
          check: ''
        },
        {
          path: '/home/message',
          check: ''
        },
        {
          path: '/home/voucher',
          check: ''
        },
        {
          path: '/home/ftpmanager',
          check: ''
        },
        {
          path: '/home/cloudDisk',
          check: ''
        }, {
          path: '/home/invoice',
          check: ''
        }
      ],
      userCenterCount: {
        orderWaitPayCount: 0,
        orderProducingCount: 0,
        orderProducedCount: 0,
        allVoucherCount: 0,
        voucherCount: 0,
        producedFileCount: 0,
        cartCount: 0
      }
    }
  },
  mounted () {
    let routePath = this.$route.path
    this.menu.forEach((item, index) => {
      if (item.path === routePath) {
        this.menu[index].check = 'active'
      } else {
        this.menu[index].check = ''
      }
    })
    this.user = JSON.parse(sessionStorage.getItem('user'))
    // 获取头部统计数量信息
    this.getUserCenterCount()

    eventBus.$on('toAccountMenu', xxx => {
      this.menu.forEach((item, index) => {
        if (index === 0) {
          this.menu[index].check = 'active'
        } else {
          this.menu[index].check = ''
        }
      })
    })
    eventBus.$on('toMessageMenu', xxx => {
      this.menu.forEach((item, index) => {
        if (index === 4) {
          this.menu[index].check = 'active'
        } else {
          this.menu[index].check = ''
        }
      })
    })
  },
  computed: {
    sex () {
      return this.user.sex
    },
    rank () {
      return this.user.rank
    }
  },
  methods: {
    menuClick (currentMenu) {
      this.menu.forEach((item, index) => {
        if (item.path === currentMenu) {
          this.menu[index].check = 'active'
        } else {
          this.menu[index].check = ''
        }
      })
      this.topMenuActive = false
      this.$router.push(`${currentMenu}`)
    },
    getUserCenterCount () {
      this.sapost('/dmc/account/userCenterCount', '', r => {
        if (r.data.retCode === '0') {
          this.userCenterCount = r.data
        }
      })
    },
    changeStatus (value) {
      // 更改订单选中样式
      this.menu.forEach((item, index) => {
        if (index === 1) {
          this.menu[index].check = 'active'
        } else {
          this.menu[index].check = ''
        }
      })
      // 调用订单页面的更改状态方法
      this.orderStatus = value
    },
    cloudDisk () {
      // 更改为我的云盘选中
      this.menu.forEach((item, index) => {
        if (index === 7) {
          this.menu[index].check = 'active'
        } else {
          this.menu[index].check = ''
        }
      })
    },
    voucher () {
      // 更改为代金券选中
      this.menu.forEach((item, index) => {
        if (index === 5) {
          this.menu[index].check = 'active'
        } else {
          this.menu[index].check = ''
        }
      })
    },
    showauthor () {
      this.authorFormVisible = true
      this.authType = false
    },
    currentUser (userItem) {
      this.user.sex = userItem.sex
      this.user.nickName = userItem.nickname
      eventBus.$emit('changeUser', this.user)
    },
    closeHandler () {
      this.authType = true
      this.title = '选择认证类型'
    },
    closeDialog () {
      this.authorFormVisible = false
    },
    getTitle (value) {
      this.title = value
    },
    defaultActive (value) {
      this.topMenuActive = value
    },
    getTopMenuStatus (status) {
      this.topMenuStatus = status
    }
  },
  watch: {
    sex (value) {
      if (value === 'm') {
        this.agent = '男'
      } else if (value === 'f') {
        this.agent = '女'
      } else {
        this.agent = '保密'
      }
    },
    rank (value) {
      switch (value) {
        case 'R2':
          this.userLevel = '铜牌'
          break
        case 'R3':
          this.userLevel = '银牌'
          break
        case 'R4':
          this.userLevel = '金牌'
          break
        case 'R5':
          this.userLevel = '钻石'
          break

        default:
          this.userLevel = '普通'
          break
      }
    }
  }
}
</script>

<style lang="less">
.mtop {
  height: 120px;
  background-color: #122644;
  margin-bottom: 15px;
  position: relative;
  z-index: 99;
  .m-top-text {
    width: 1100px;
    margin: 0 auto;
    padding-left: 70px;
    .userInfo {
      color: #fff;
      display: inline;
      padding-left: 10px;
      img {
        float: left;
        margin-top: 35px;
        width: 100px;
        height: 100px;
        border-radius: 50px;
      }
      .text {
        float: left;
        margin-top: 38px;
        margin-left: 20px;
        line-height: 2em;
        .uname {
          font-size: 20px;
        }
      }
    }
    .main-nav {
      float: left;
      margin-top: 35px;
      font-size: 16px;
      margin-left: 60px;
      ul {
        li {
          height: 20px;
          line-height: 20px;
          float: left;
          padding: 0 15px;
          border-right: 2px solid #c3c7cd;
          span {
            display: block;
            margin-top: 10px;
            text-align: center;
          }
          a {
            color: #c3c7cd;
          }
        }
        li:last-child {
          border-right: none;
        }
        li.active,
        li:hover {
          a {
            color: #86b1bf;
          }
        }
      }
    }
    .userreset {
      float: right;
      margin-top: 35px;
      span {
        display: inline-block;
        color: #c3c7cd;
        padding: 5px 15px;
        border: 1px solid #c3c7cd;
        border-radius: 15px;
      }
    }
  }
}
.main-text {
  width: 1100px;
  margin: 17px auto;
  overflow: hidden;
  position: relative;
  top: -16px;
  z-index: 9;
  min-height: 488px;
  background-color: #f8fafc;
  .left-nav {
    float: left;
    width: 200px;
    padding: 30px 00px 0px 0px;
    font-size: 16px;
    height: 100%;
    li {
      line-height: 46px;
      height: 46px;
      margin-left: 30px;
      padding-left: 20px;
      margin-right: 30px;
      text-align: left;
      i {
        margin-right: 15px;
      }
      a {
        color: #93999f;
      }
    }
    li.active,
    li:hover {
      a {
        color: #fff;
      }
      background-color: #f14242;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      span {
        position: absolute;
        left: 170px;
        display: inline-block;
        height: 0;
        width: 0;
        border-top: 23px solid transparent;
        border-bottom: 23px solid transparent;
        border-left: 15px solid #f14242;
      }
    }
    li:hover {
      background-color: #f97575;
      span {
        border-left: 15px solid #f97575;
      }
    }
  }
  .text-right {
    margin-left: 200px;
    padding-left: 30px;
    background-color: #fff;
    .t-nav {
      nav {
        border-bottom: 2px solid #ddd;
        ul {
          margin-right: 150px;
          height: 60px;
          color: #b4b8bb;
          li {
            float: left;
            height: 60px;
            line-height: 60px;
            font-size: 15px;
            margin-right: 16px;

            a {
              color: #b4b8bb;
            }
          }
          li.active,
          li:hover {
            border-bottom: 2px solid #f01400;
          }
        }
      }
    }
    .r-title {
      float: right;
      height: 60px;
      line-height: 60px;
      span {
        color: #f01400;
      }
    }
    .pages {
      text-align: right;
      padding-top: 15px;
    }
  }
}
.router-link-exact-active {
  border-bottom: #1ccb96 0px solid;
}
.el-dialog__wrapper {
  .authordialog {
    width: 420px;
    padding: 0px 0px 20px 0px;
    .el-dialog__title {
      font-size: 16px;
    }
    .el-dialog__header {
      padding-bottom: 0px;
      background: #fff;
      .el-dialog__title {
        line-height: 24px;
        color: #303133;
      }
      .el-dialog__headerbtn .el-dialog__close {
        color: #909399;
      }
    }
    .el-dialog__body {
      padding: 10px 0 0 0;
    }
    p {
      font-size: 12px;
      line-height: 24px;
      background-color: #fdeeec;
      color: #f3978f;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/userCenter/home.vue